import { render, staticRenderFns } from "./wristband.vue?vue&type=template&id=0f0c85b7&scoped=true&"
import script from "./wristband.vue?vue&type=script&lang=js&"
export * from "./wristband.vue?vue&type=script&lang=js&"
import style0 from "./wristband.vue?vue&type=style&index=0&id=0f0c85b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0c85b7",
  null
  
)

export default component.exports